<template>

  <v-container fluid>
    <PdfModal v-model="mostrarPdfFactura" title="Vista de" :file-name="`Factura ${this.idReciboSelect}`"
      :fetch-document="obtenerPdfFactura" />
    <v-col cols="12" md="10" lg="8">
      <h2 class="header-title-int">
        Recibos de pagos
      </h2>
      <p class="header-subtitle grey--text">
        Recuerda: mantener tus pagos al día evita la <strong>suspensión</strong> de tu membresía.
      </p>
    </v-col>
    <tabla-pagos :loading="loadingRecibos" :recibos="this.recibos" :actions="tableActions"
      @action-selected="onActionSelected"></tabla-pagos>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import PdfModal from "@/components/PdfModalComponent.vue";

export default {
  name: 'UserRecibos',
  components: {
    TablaPagos: () => import('@/components/Pagos/tablaPagos.vue'),
    PdfModal
  },
  computed: {
    ...mapGetters(["getIdTarjetaTxt", "getIdTarjeta"]),
  },
  watch: {
    "$route.params.mem"(newVal) {
      if (newVal) {
        this.numRecibo = newVal;
        this.getDatos();
      }
    }
  },
  mounted() {
    this.numRecibo = this.$route.params.recibo || null;
  },
  created() {
    this.getRecibosMembresia()
  },
  data() {
    return {
      loadingRecibos: false,
      numRecibo: null,
      recibos: [],
      tableActions: [
        'VER RECIBO'
      ],
      mostrarPdfFactura: false,
      idReciboSelect: null,
      tipoFactura: null,
    }
  },
  methods: {
    async obtenerPdfFactura() {
      return await this.$http.get(`file/${this.idReciboSelect}/RECIBO_PAGO/pdf`,
        {
          responseType: 'blob'
        })
    },
    verRecibo() {
      this.mostrarPdfFactura = true
    },
    getRecibosMembresia() {
      this.loadingRecibos = true
      this.$http.get(`payment/membresia?contrato=${this.getIdTarjeta}`)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.recibos = response.data
            }
          }
        })
        .catch(() => {
          this.$swal.fire({
            position: 'center',
            html: `Ha ocurrido un error, el cual ya ha sido reportado, <b>intenta mas tarde</b>.`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            //timer: 1500,
          })
        }).finally(() => {
          this.loadingRecibos = false
        });
    },
    onActionSelected(action, item) {
      this.MembresiaSelect = { ...item }
      switch (action) {
        case 'VER RECIBO':
          this.idReciboSelect = item.Folio
          this.verRecibo()
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Estilo para el contenedor del título con ícono */
.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  font-family: 'Roboto', sans-serif;
}

/* Estilo para el ícono */
.title-icon {
  font-size: 36px;
  /* Tamaño del ícono */
  color: #4caf50;
  /* Verde para el ícono */
  margin-right: 8px;
  /* Espacio entre el ícono y el texto */
}

/* Estilo para el texto */
.title-text {
  font-size: 18px;
  /* Tamaño del texto */
  font-weight: 500;
  /* Peso medio para el texto */
  color: #333;
  /* Color oscuro para el texto */
  text-transform: uppercase;
  /* Mayúsculas */
  letter-spacing: 1px;
  /* Espaciado entre letras */
}
</style>